import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'app/reducer';
import { PROFILE_EDIT_TYPE } from 'app/constants/profile';
import EditBasicInformation from './EditBasicInformation';
import EditProfileImage from './EditProfileImage';

const EditProfileForm = props => {
  const { editType } = props;

  // Selectors
  const profile = useSelector((state: RootState) => state.profile.user);

  switch (editType) {
    case PROFILE_EDIT_TYPE.BASIC:
      return <EditBasicInformation profile={profile} />;
    case PROFILE_EDIT_TYPE.PICTURE:
      return <EditProfileImage profile={profile} />;
    default:
    case PROFILE_EDIT_TYPE.MOBILE:
      return (
        <>
          <EditProfileImage profile={profile} />
          <EditBasicInformation profile={profile} renderCredentialWithModal />
        </>
      );
  }
};

export default EditProfileForm;
